export const header = 'Διαχείριση Διαθεσιμότητας Νοσοκομείου';
